<template>
  <h2 class="component island-title">
    <slot></slot>
  </h2>
</template>
 
<script>
export default {
  name: 'IslandTitle',
};
</script>

<style lang="scss">
@import "../styles/variables.scss";

.component.island-title {
  margin: 0;
  font-size: (16/14)*1em;
  font-weight: 500;
  letter-spacing: -0.01em;
}
</style>


